import React from 'react';
import { ArticleSection } from './ArticleSection';
import { selectionCriteria } from '../../data/articleLists';
export function SelectionCriteriaSection() {
  return <ArticleSection id="selection" title="How to Choose an AI Workflow Automation Provider" data-id="element-127" data-mp="2chi8h8vh84cm">
      <p data-id="element-128" data-mp="2cjuy887h7j08">
        Demos are easy to make impressive. What matters is how a provider behaves when data is messy,
        systems are old and a decision carries real risk. Use these criteria in every discovery call:
      </p>
      <dl className="!mt-6 grid gap-x-10 sm:grid-cols-2" data-id="element-129" data-mp="2qgroo8jomygl">
        {selectionCriteria.map(item => <div key={item.title} className="border-t border-line py-5" data-id="element-130" data-mp="2v7ghbr73m1hb">
            <dt className="font-semibold text-ink" data-id="element-131" data-mp="2vacgtjylgy7v">{item.title}</dt>
            <dd className="mt-1.5 text-[0.975rem] leading-7 text-muted" data-id="element-132" data-mp="306jnxg2q8fre">{item.text}</dd>
          </div>)}
      </dl>
      <p data-id="element-133" data-mp="354cq7y0wspme">
        A useful test: ask each provider to describe a workflow that did not work as planned and what they
        changed. Honest answers reveal more about delivery maturity than any case study.
      </p>
    </ArticleSection>;
}